<script setup lang="ts">
import { computed } from "vue";

export interface Props {
  fillColor?: string;
  rotateDirection?: "down" | "up" | "right" | "left";
  height?: string | number;
  width?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
  fillColor: "#1E264C",
  rotateDirection: "down",
  height: "11",
  width: "20",
});

const viewBox = computed<string>(() => `0 0 20 11`);

const rotateClass = computed(() => {
  return `search-chevron-${props.rotateDirection}`;
});
</script>

<template>
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
    class="feather feather-chevron-down transition-transform transform"
    :class="rotateClass"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.80586 4.40739L17.2134 10.9844L19.6113 8.67538L9.8181 -0.000335569L0.000396937 8.67537L2.38605 10.9844L9.80586 4.40739Z"
      :fill="fillColor"
    ></path>
  </svg>
</template>

<style scoped>
.search-chevron-down {
  transform: rotate(180deg);
}

.search-chevron-up {
  transform: rotate(0deg);
}

.search-chevron-right {
  transform: rotate(90deg);
}

.search-chevron-left {
  transform: rotate(270deg);
}
</style>
